import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@awaze/design-system.components.badge';
import { UspListStyled } from './usp-list.styles';
/**
 * A component that displays a list of USPs as badges. It will also display a 'Pets stay free' badge if hasPetsFree is set to true.
 */
export const UspList = ({ hasPetsFree, uspList, className, labels = { petsFree: 'Pets stay free' }, }) => {
    return (_jsxs(UspListStyled, { className: className, "data-testid": "usp-list", children: [hasPetsFree && (_jsx(Badge, { variant: "outline", colourScheme: "primary", text: labels.petsFree })), uspList.length > 0 &&
                uspList.map((usp, index) => (_jsx(Badge, { text: usp.value, variant: "outline", colourScheme: "tertiary" }, usp.id ?? `default_${index}`)))] }));
};
//# sourceMappingURL=usp-list.js.map